import { Box, Paper, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useAppNavigate } from "../../../_hooks/use-app-navigate";
import Connect from "../../../_components/Connect";
import { ButtonStyled } from "../../../_components/ButtonStyled";
import Text from "../../../_components/Text";
import { useTranslation } from "react-i18next";

const StubAccount = () => {
  const theme = useTheme();
  const navigate = useAppNavigate();
  const { t } = useTranslation("bots");

  return (
    <Paper
      elevation={0}
      className="base-adron-paper paper-light"
      style={{ backgroundColor: theme.myTheme.colors.tertiary }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          paddingBottom: 2,
        }}
      >
        <Stack direction={"row"} gap={2} alignItems="center">
          <Connect size={36} />
          <Text variant="regular-semi">{t("didntConnect")}</Text>
        </Stack>
      </Box>

      <ButtonStyled
        onClick={() => navigate.accountAdd()}
        style={{ padding: "8px 16px", color: "#fff" }}
        fullWidth={true}
        color={"primary"}
        variant="contained"
      >
        {t("connectAccount")}
      </ButtonStyled>
    </Paper>
  );
};

export default StubAccount;
